/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const FacebookOptinIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M15.6844 12.1164H15.3337V3.47896C15.3337 2.95686 14.9091 2.53218 14.3871 2.53218H14.0521C13.8778 2.53218 13.7366 2.67354 13.7366 2.84773C13.7366 3.02205 13.8778 3.16341 14.0521 3.16341H14.3871C14.561 3.16341 14.7026 3.30489 14.7026 3.47896V12.0773H1.41223V3.47896C1.41223 3.30489 1.55383 3.16341 1.72778 3.16341H11.5327C11.707 3.16341 11.8483 3.02205 11.8483 2.84773C11.8483 2.67354 11.707 2.53218 11.5327 2.53218H1.72778C1.20581 2.53218 0.781006 2.95686 0.781006 3.47896V12.1164H0.315552C0.141235 12.1164 0 12.2576 0 12.432V14.0218C0 14.5438 0.424683 14.9686 0.946777 14.9686H15.0532C15.5753 14.9686 16 14.5438 16 14.0218V12.432C16 12.2576 15.8588 12.1164 15.6844 12.1164ZM15.3689 14.0218C15.3689 14.1958 15.2273 14.3374 15.0532 14.3374H0.946777C0.772705 14.3374 0.631104 14.1958 0.631104 14.0218V12.7475H15.3689V14.0218Z"
          fill={color}
        />
        <path
          d="M2.24561 4.23068V11.0536C2.24561 11.2279 2.38684 11.3691 2.56116 11.3691H13.6858C13.8601 11.3691 14.0013 11.2279 14.0013 11.0536V5.84945C14.0013 5.84921 14.0013 5.84908 14.0013 5.84896L13.9989 4.23019C13.9987 4.05599 13.8574 3.91512 13.6832 3.91512H2.56116C2.38684 3.915 2.24561 4.05636 2.24561 4.23068ZM2.87671 4.54623H13.3682L13.3701 5.84994V10.738H2.87671V4.54623Z"
          fill={color}
        />
        <path
          d="M6.96826 13.9115H9.27197C9.44629 13.9115 9.58752 13.7703 9.58752 13.596C9.58752 13.4217 9.44629 13.2804 9.27197 13.2804H6.96826C6.79395 13.2804 6.65271 13.4217 6.65271 13.596C6.65271 13.7703 6.79395 13.9115 6.96826 13.9115Z"
          fill={color}
        />
        <path
          d="M1.4994 13.8974L1.50526 13.8991C1.53541 13.9082 1.5658 13.9124 1.59571 13.9124C1.73157 13.9124 1.85706 13.8241 1.89796 13.6872C1.94788 13.5201 1.85303 13.3443 1.68604 13.2944L1.68018 13.2927C1.51319 13.2428 1.33729 13.3377 1.28748 13.5047C1.23756 13.6716 1.3324 13.8475 1.4994 13.8974Z"
          fill={color}
        />
        <path
          d="M2.28613 13.8974L2.29187 13.8992C2.32214 13.9082 2.35254 13.9125 2.38257 13.9125C2.51843 13.9125 2.6438 13.8241 2.68481 13.6874C2.73474 13.5205 2.64002 13.3446 2.47314 13.2946L2.46729 13.2929C2.30042 13.2427 2.12439 13.3375 2.07434 13.5045C2.02429 13.6714 2.11914 13.8473 2.28613 13.8974Z"
          fill={color}
        />
        <path
          d="M3.07312 13.8974L3.07898 13.8991C3.10913 13.9082 3.13964 13.9124 3.16955 13.9124C3.30542 13.9124 3.4309 13.8241 3.4718 13.6872C3.52172 13.5201 3.42675 13.3443 3.25976 13.2944L3.2539 13.2927C3.08691 13.2428 2.91113 13.3377 2.8612 13.5047C2.81128 13.6716 2.90625 13.8475 3.07312 13.8974Z"
          fill={color}
        />
        <path
          d="M12.9131 13.8974L12.9188 13.8992C12.9491 13.9082 12.9796 13.9125 13.0097 13.9125C13.1454 13.9125 13.2708 13.8241 13.3118 13.6874C13.3618 13.5205 13.2671 13.3446 13.1001 13.2946L13.0942 13.2929C12.9274 13.2427 12.7514 13.3375 12.7014 13.5045C12.6514 13.6714 12.7461 13.8473 12.9131 13.8974Z"
          fill={color}
        />
        <path
          d="M13.7002 13.8974L13.7061 13.8991C13.7362 13.9082 13.7666 13.9124 13.7965 13.9124C13.9324 13.9124 14.0579 13.8241 14.0988 13.6872C14.1487 13.5201 14.0538 13.3443 13.8868 13.2944L13.881 13.2927C13.7139 13.2428 13.5381 13.3377 13.4883 13.5047C13.4384 13.6716 13.5332 13.8475 13.7002 13.8974Z"
          fill={color}
        />
        <path
          d="M14.4869 13.8974L14.4927 13.8992C14.5229 13.9082 14.5533 13.9125 14.5834 13.9125C14.7192 13.9125 14.8446 13.8241 14.8856 13.6874C14.9355 13.5205 14.8408 13.3446 14.6739 13.2946L14.6681 13.2929C14.5011 13.2427 14.3252 13.3375 14.2751 13.5045C14.2251 13.6714 14.3199 13.8473 14.4869 13.8974Z"
          fill={color}
        />
        <path
          d="M12.7067 3.14933L12.7125 3.15104C12.7427 3.16008 12.7732 3.16435 12.8031 3.16435C12.939 3.16435 13.0644 3.07597 13.1053 2.93913C13.1553 2.77214 13.0603 2.59623 12.8933 2.54631L12.8874 2.5446C12.7205 2.49467 12.5447 2.58964 12.4947 2.75663C12.4448 2.92363 12.5398 3.09941 12.7067 3.14933Z"
          fill={color}
        />
        <rect
          x="4"
          y="5.89286"
          width="6"
          height="0.666667"
          rx="0.333333"
          fill={color}
        />
        <rect
          x="4"
          y="8.17857"
          width="6"
          height="0.666667"
          rx="0.333333"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8571 7.32143C12.4094 7.32143 12.8571 6.87371 12.8571 6.32143C12.8571 5.76914 12.4094 5.32143 11.8571 5.32143C11.3048 5.32143 10.8571 5.76914 10.8571 6.32143C10.8571 6.87371 11.3048 7.32143 11.8571 7.32143ZM11.363 6.27371L11.6361 6.08256L11.8055 6.32456L12.0238 5.8214L12.3571 5.98809L11.9458 6.83685L11.7454 6.81986L11.7454 6.81986L11.363 6.27371Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8571 9.60714C12.4094 9.60714 12.8571 9.15943 12.8571 8.60714C12.8571 8.05486 12.4094 7.60714 11.8571 7.60714C11.3048 7.60714 10.8571 8.05486 10.8571 8.60714C10.8571 9.15943 11.3048 9.60714 11.8571 9.60714ZM11.363 8.55943L11.6361 8.36827L11.8055 8.61027L12.0238 8.10711L12.3571 8.27381L11.9458 9.12256L11.7454 9.10557L11.7454 9.10558L11.363 8.55943Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0.75H16V16.75H0V0.75Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
